/*
 *
 * PluginLoader reducer
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

function pluginLoaderReducer(state = fromJS({}), action) {
  switch (action.type) {
    case constants.SET_PLUGIN_SCHEMA:
      return state
        .set(action.pluginId, action.schema);
    default:
      return state;
  }
}

export default pluginLoaderReducer;
